import ButtonField from "../../../../components/buttonField/buttonField";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { styleFormField, stylizationVerticalAlign } from "../../../../components/shared/stylization";
import { InstitutionDictionaryType, ProtocolDictionaryTypes } from "../../poFormView/types/poFormViewProps";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import Table from "../../../../components/shared/table/table";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import { useContext, useEffect, useState } from "react";
import AuthorsAddModal from "./authorsAddModal/authorsAddModal";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { AuthorsAddModalProps } from "./authorsAddModal/types/authorsAddModalProps";
import PoFormContext, { AuthorsAttributes, ElaboratorAttributes, InstitutionsAttributes } from "../../../../contexts/poFormContext";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { SelectInputProps } from "../../../../components/shared/selectInput/types/selectInputProps";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import { TabbarOption } from "../../../../components/shared/tabbar/types/tabbarProps";
import { InstitutionsAddModalProps } from "./institutionsAddModal/types/institutionsAddModalProps";
import InstitutionsAddModal from "./institutionsAddModal/institutionsAddModal";
import { apiContext } from "../../../../contexts/apiContext";
import { notifyError, notifySuccess } from "../../../../components/snackbar/snackbar";
import { ElaboratorsAndInstitutionsProps } from "./types/elaboratorsAndInstitutionsProps";
import { AddAuthorInstitutionDictProposalProps } from "../../../../services/dictionariesService/types/dictionariesServiceProps";
import { addAuthorInstitutionDictProposal } from "../../../../services/dictionariesService/dictionariesService";
import './elaboratorsAndInstitutions.scss';
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import PermissionsContext from "../../../../contexts/permissionsContext";
import CollectiveLabelChip from "../../collectiveEditionView/components/collectiveLabelChip";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { checkIfMarkedForCommentFilter, fireAddCommentBtnOnClickForRow, getFieldRef, getFieldRefForRow, getItemRef, getKRDictFieldNameForRow, renderSectionCommentBtn } from "../../../../helpers/form";
import KrFormContext, { NavHeadingsKROEnum, NavHeadingsKRTZEum } from "../../../../contexts/krFormContext";
import { ObjectType } from "../../../../contexts/types/card";
import { KROFieldDict, KRTZFieldDict } from "../commentsSidebar/fieldDict";
import AuthContext from "../../../../contexts/authContext";
import { setDictProposition } from "../../../../database/indexedDbReadWrite";
import Spinner from "../../../../components/spinner/spinner";
import { ClassNameSpinner } from "../../../../components/spinner/types/spinnerProps";

const ElaboratorsAndInstitutions = (props: ElaboratorsAndInstitutionsProps) => {
    const api = useContext(apiContext);
    const { username, onlineMode } = useContext(AuthContext);
    const { local } = useContext(KrFormContext);
    const { localPo } = useContext(PoFormContext);
    const { functionsPermissions } = useContext(PermissionsContext);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [elaboratorRow, setElaboratorRow] = useState<any>(null);
    const [selectedAuthor, setSelectedAuthor] = useState<Option[]>([]);
    const [selectedInstitution, setSelectedInstitution] = useState<Option[]>([]);
    const [newElaborator, setNewElaborator] = useState<ElaboratorAttributes>({});
    const [tableData, setTableData] = useState<ElaboratorAttributes[]>([]);
    const [selectedTab, setSelectedTab] = useState(InstitutionDictionaryType.PerAuthor);
    const [filteredInstitutionsDictPerAuthor, setFilteredInstitutionsDictPerAuthor] = useState<InstitutionsAttributes[] | undefined>([]);
    const [filteredInstitutionsDictMinusAuthor, setFilteredInstitutionsDictMinusAuthor] = useState<InstitutionsAttributes[] | undefined>([]);
    const [authorModalVisible, setAuthorModalVisible] = useState(false);
    const [institutionModalVisible, setInstitutionModalVisible] = useState(false);
    const [cleanAuthorSelect, setCleanAuthorSelect] = useState<boolean>(false);
    const [cleanInstitutionSelect, setCleanInstitutionSelect] = useState<boolean>(false);
    const [enableClean, setEnableClean] = useState<boolean>(false);
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>('');
    const [focusTable, setFocusTable] = useState<boolean>(false);
    const [focusAuthorSelect, setFocusAuthorSelect] = useState<boolean>(false);
    const [focusInstitutionSelect, setFocusInstitutionSelect] = useState<boolean>(false);
    const [academicTitleDict, setAcademicTitleDict] = useState<Option[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    const refocusAuthorSelect = () => {
        setFocusAuthorSelect(true);
    }

    const refocusInstitutionSelect = () => {
        setFocusInstitutionSelect(true);
    }

    const krFieldDict = props.objectType === ObjectType.KRO ? KROFieldDict.oprac_opracowujacy : props.objectType === ObjectType.KRTZ ? KRTZFieldDict.oprac_opracowujacy : undefined;

    // Validation
    useEffect(() => {
        if (props.context.config?.check && !props.context.config.isValid) {
            var errorMsg = props.context.config?.ValidationError!["elaborators"]
            if (errorMsg !== '') {
                setTableError(true);
                setTableErrorMsg(errorMsg);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.context.config?.check])

    // Get academic title coded values
    useEffect(() => {
        if (props.context.dictionariesCodedValues) setAcademicTitleDict(props.context.dictionariesCodedValues["TYTUL"]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Search selects (author & institution)

    // Prepare institutions per author dictionary & filter full institution dictionary
    useEffect(() => {
        if (selectedAuthor.length > 0) {
            var relationsDict: (number | undefined)[] = [];
            props.context.dicts?.authorInstitutionsDict?.forEach((item: any) => {
                if (item.autoR_ID === selectedAuthor[0].value) relationsDict.push(item.instytucjA_ID);
            })
            var filteredInstitutionsDictPerAuthor = props.context.dicts?.institutionsDict?.filter((item: any) => relationsDict?.includes(item.id))
            ?.sort((a: InstitutionsAttributes, b: InstitutionsAttributes) => a.nazwa!.localeCompare(b.nazwa!, 'pl'));
            var filteredInstitutionsDictMinusAuthor = props.context.dicts?.institutionsDict?.filter((item: any) => !relationsDict?.includes(item.id))
            ?.sort((a: InstitutionsAttributes, b: InstitutionsAttributes) => a.nazwa!.localeCompare(b.nazwa!, 'pl'));
            setFilteredInstitutionsDictPerAuthor(filteredInstitutionsDictPerAuthor);
            setFilteredInstitutionsDictMinusAuthor(filteredInstitutionsDictMinusAuthor);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAuthor]);

    const getSelectProps = (label: string, placeholder: string, options: Option[] | undefined, selectedOptions: Option[], disabled: boolean, onChange: Function,
        clean: boolean, btnFieldProps: ButtonFieldProps, isSelectOpen: boolean, errorMsg: any, btnVisible?: boolean, refocus?: boolean, setRefocusButton?: Function, 
        tabbarVisible?: boolean, tabbarOptions?: TabbarOption[], selectedTab?: InstitutionDictionaryType, alternateTab?: number, alternateOptions?: Option[]): SelectInputProps => {
        return {
            label: label,
            placeHolder: placeholder,
            hasInputTags: true,
            onlySingleTag: true,
            options: options,
            selectedOptions: selectedOptions,
            disabled: disabled,
            style: styleFormField,
            onChange: onChange,
            enableClean: enableClean,
            cleanSelected: clean,
            optionsField: {
                isVisible: true,
                btnFieldProps: btnFieldProps,
                btnVisible: btnVisible,
                isSelectOpen: isSelectOpen,
                errorMsg: errorMsg,
                tabbarVisible: tabbarVisible,
                tabbarOptions: tabbarOptions,
                selectedTab: selectedTab,
                setTabToDefault: () => { setSelectedTab(InstitutionDictionaryType.PerAuthor) },
                tabForAlternateOptions: alternateTab,
                alternateOptions: alternateOptions
            },
            refocus: refocus,
            setRefocusButton: setRefocusButton
        };
    }

    const cleanSelects = () => {
        if (!enableClean) setEnableClean(true);
        setCleanAuthorSelect(!cleanAuthorSelect);
        setCleanInstitutionSelect(!cleanInstitutionSelect);
        setSelectedAuthor([]);
        setSelectedInstitution([]);
    }

    const prepareSelect = (dict: ProtocolDictionaryTypes, institutionsMinusAuthorFilter?: boolean) => {
        switch (dict) {
            case ProtocolDictionaryTypes.Authors:
                
            var authorSelect: Option[] | undefined = props.context.dicts?.authorsDict?.sort((a: AuthorsAttributes, b:AuthorsAttributes) => a.nazwisko!.localeCompare(b.nazwisko!, 'pl'))
            ?.map((item: any) => {
                    return {
                        value: item.id,
                        name: `${getAcademicTitle(item.tytul)} ${item.imie} ${item.nazwisko}, ${item.uprawnienia}`
                    };
                });
                return authorSelect;
            case ProtocolDictionaryTypes.Institutions:
                if (institutionsMinusAuthorFilter) {
                    var institutionMinusAuthorSelect: Option[] | undefined = filteredInstitutionsDictMinusAuthor!.map((item: any) => {
                        return {
                            value: item.id,
                            name: item.nazwa
                        };
                    });
                    return institutionMinusAuthorSelect;
                }
                else {
                    var institutionSelect: Option[] | undefined = props.context.dicts?.institutionsDict?.map((item: any) => {
                        return {
                            value: item.id,
                            name: item.nazwa
                        };
                    });
                    return institutionSelect;
                }
            case ProtocolDictionaryTypes.InstitutionsPerAuthor:
                var institutionPerAuthorSelect: Option[] | undefined = filteredInstitutionsDictPerAuthor!.map((item) => {
                    return {
                        value: item.id,
                        name: item.nazwa
                    };
                });
                return institutionPerAuthorSelect;
        }
    }

    const AuthorSelectOnChange = (opt: Option[]) => {
        setSelectedAuthor(opt);
        setSelectedInstitution([]);
        if (opt !== undefined && opt.length > 0) {
            var dictItem = props.context.dicts?.authorsDict?.find((item: any) => item.id === opt![0].value);
            var elaborator: ElaboratorAttributes = {
                ...newElaborator,
                imie: dictItem!.imie,
                nazwisko: dictItem!.nazwisko,
                uprawnienia: dictItem!.uprawnienia,
                tytul: dictItem!.tytul,
                firmA_MIEJSCOWOSC: undefined,
                firmA_NAZWA: undefined
            }
            setNewElaborator(elaborator);
        }
        else setNewElaborator({});
    }

    const InstitutionSelectOnChange = (opt: Option[]) => {
        setSelectedInstitution(opt);
        if (opt !== undefined && opt.length > 0) {
            var dictItem = props.context.dicts?.institutionsDict?.find((item: any) => item.id === opt![0].value);
            var elaborator: ElaboratorAttributes = {
                ...newElaborator,
                firmA_NAZWA: dictItem!.nazwa,
                firmA_MIEJSCOWOSC: dictItem!.miejscowosc
            }
            setNewElaborator(elaborator);
        }
        else {
            var clearElaborator: ElaboratorAttributes = {
                ...newElaborator,
                firmA_NAZWA: undefined,
                firmA_MIEJSCOWOSC: undefined
            }
            setNewElaborator(clearElaborator);
        }
    }

    const getSelectButtonFieldProps = (onClick: Function, title: string): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: () => { onClick() },
                className: classNameBtn.Small,
                disabled: false,
                style: {
                    padding: '5px 10px 5px 10px',
                    gap: '10px'
                }
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: addCircleIcon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    padding: '10px'
                }
            }
        };
    }

    const getOptionsFieldErrorMsg = (mainText: string, linkText: string, onClick: Function) => {
        return (
            <>
                <p>{mainText}</p>
                {functionsPermissions.proposeNewDictValue.active && <p onClick={() => { onClick() }} style={{ cursor: "pointer" }}><b>{linkText}</b></p>}
            </>
        )
    }

    const getTabTitle = (title: string, count: number) => {
        return (
            <>
                <p>{title}</p>
                <p className="tab-title-bubble"> {count} </p>
            </>
        )
    }

    const onClickTabbarOption = (navigate: number) => {
        setSelectedTab(navigate);
    }

    const handleAddAuthorProposalClick = () => {
        setAuthorModalVisible(true);
    }

    const handleAddInstitutionProposalClick = () => {
        setInstitutionModalVisible(true);
    }

    // Add elaborator button
    var btnFieldProps: ButtonFieldProps = {
        BtnProps: {
            onClick: () => { onAddElaborator() },
            className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium searchBtn`,
            style: {
                marginTop: "28px"
            },
            disabled: !(selectedAuthor.length > 0 && selectedInstitution.length > 0)
        },
        placeHolder: "Dodaj",
        placeHolderStyle: stylizationVerticalAlign,
        wrapperProps: {
            className: "searchBtnField"
        }
    }

    const getAcademicTitle = (titleCode?: string) => {
        var academicTitle = "";
        if (titleCode) {
            if (academicTitleDict) {
                var option = academicTitleDict.find(item => item.value === titleCode);
                academicTitle = option && option.name ? option.name : "";
            }
        }
        return academicTitle;
    }

    const onAddElaborator = () => {
        cleanSelects();

        if (selectedTab === InstitutionDictionaryType.PerAuthor) {
            var academicTitle = getAcademicTitle(newElaborator.tytul);
            
            var elaborator: ElaboratorAttributes = {
                ...newElaborator,
                tytul: academicTitle,
                localUUID: crypto.randomUUID()
            }

            var form: any = Object.assign({}, props.context);
            var newElaborators: any[] = [...form.elaborators, elaborator]
            form.elaborators = newElaborators;
            if (tableError) {
                refreshValidation(newElaborators);
            }
            props.setContext!(form);
        }
        else {
            let addAuthorInstitutionDictProposalProps: AddAuthorInstitutionDictProposalProps = {
                selectedAuthorId: selectedAuthor.length > 0 ? selectedAuthor[0].value : "",
                selectedInstitutionId: selectedInstitution.length > 0 ? selectedInstitution[0].value : "",
                apiBase: api.apiUrl + api.apiVersion
            }
            if ((local || localPo) && !onlineMode) {
                setDictProposition(username, addAuthorInstitutionDictProposalProps, "authorLinkInstitution").then((response) => {
                    notifySuccess({ message: "Dodano propozycję powiązania autora i instytucji, propozycja zostanie zsynchronizowana po przejściu na tryb online" });
                    cleanSelects();
                }).catch(() => {
                    notifyError({ message: "Dodanie propozycji powiązania autora i instytucji zakończone niepowodzeniem" });
                })
            } else {
                setLoading(true);
                addAuthorInstitutionDictProposal(addAuthorInstitutionDictProposalProps)
                    .then(() => {
                        notifySuccess({ message: "Dodano propozycję powiązania autora i instytucji" });
                        cleanSelects();
                    })
                    .catch(() => {
                        notifyError({ message: "Dodanie propozycji powiązania autora i instytucji zakończone niepowodzeniem" });
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        }
    }

    const refreshValidation = (values: ElaboratorAttributes[]) => {
        const currValidation = createConfigValidation("elaborators", false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setTableError(true);
            setTableErrorMsg(currValidationMsg);
        } else {
            setTableError(false);
            setTableErrorMsg('');
        }
    }

    // Elaborators table
    useEffect(() => {
        prepareTableData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.context.elaborators]);

    const prepareTableData = () => {
        var data: ElaboratorAttributes[] = [];
        const elaborators = props.context.elaborators;
        data = elaborators ? elaborators!.map((element: any) => {
            if (element.localUUID === undefined) element.localUUID = crypto.randomUUID();
            return element;
        }) : [];

        data.sort((a, b) => a.kolejnosc! - b.kolejnosc!)

        setTableData(data);
    }

    const draggableRows = props.editMode;

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"elaborators"}
            deleteClickHandler={handleDeleteClick}
            draggableStyle={draggableRows}
            addCommentBtnVisible={!props.editMode}
            addCommentBtnClickHandler={handleAddCommentClick}
            addCommentBtnRef={getAddCommentBtnRef}
            checkIfMarkedForCommentFilter={checkIfRowMarkedForCommentFilter}
        />)
    }

    const checkIfRowMarkedForCommentFilter = (row: any) => {
        if (props.markedFieldForCommentFiltering) {
            if (krFieldDict) return checkIfMarkedForCommentFilter(krFieldDict, row.uprawnienia, props.markedFieldForCommentFiltering)
        }
    }

    const handleReorderRows = (data: ElaboratorAttributes[]) => {
        var numberedNewData = data.map((item: any, index: number) => {
            item.kolejnosc = index + 1;
            return item;
        })

        var form: any = Object.assign({}, props.context);
        if (form !== null) form.elaborators = numberedNewData;
        props.setContext!(form);
    }

    const handleAddCommentClick = (row: any) => {
        if (krFieldDict) fireAddCommentBtnOnClickForRow(krFieldDict, row.uprawnienia, "Wiersz sekcji: Opracowujący", props.setNewCommentFieldDetails!);
    }

    const getAddCommentBtnRef = (node: any, row: any) => {
        if (krFieldDict) getFieldRefForRow(node, krFieldDict, row.uprawnienia, props.getMapForComment!);
    }

    let headers = {
        tytul: "Tytuł",
        imie: "Imię",
        nazwisko: "Nazwisko",
        uprawnienia: "Uprawnienia",
        firmA_NAZWA: "Instytucja"
    };

    var tableProps: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: tableData,
        loading: false,
        className: "elaboratorsTable",
        draggableRows: draggableRows,
        handleReorderRows: handleReorderRows,
        tableError: props.collectiveEdition ? undefined : tableError,
        tableErrorMsg: props.collectiveEdition ? undefined : tableErrorMsg,
        setCommentsFilter: (row: any) => { if (props.setCommentsFilter && krFieldDict) props.setCommentsFilter(getKRDictFieldNameForRow(krFieldDict, row.uprawnienia)); },
        checkIfMarkedForCommentFilter: (row: any) => {checkIfRowMarkedForCommentFilter(row)},
        narrowTableForCommentBtns: !props.editMode,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const handleDeleteClick = (row: any) => {
        setElaboratorRow(row);
        setConfirmation(true);
    }

    const deleteElaborator = (row: any) => {
        var form: any = Object.assign({}, props.context);
        if (form !== null) {
            var newElaborators = form.elaborators.filter((item: any) => item.localUUID !== row.localUUID)
            form.elaborators = newElaborators
        }
        refreshValidation(newElaborators);
        props.setContext!(form);
    }

    const confirm = () => {
        setConfirmation(false);
        deleteElaborator(elaboratorRow);
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć osobę opracowującą ${elaboratorRow.imie} ${elaboratorRow.nazwisko}?`;
    }

    // Modals (add author & add institution)
    const onClose = (isAuthorsModal: boolean) => {
        isAuthorsModal ? setAuthorModalVisible(false) : setInstitutionModalVisible(false);
    }

    let addAuthorModalProps: AuthorsAddModalProps = {
        onClose: () => { onClose(true) },
        institutionOptions: prepareSelect(ProtocolDictionaryTypes.Institutions, false),
        cleanSelects: cleanSelects,
        refocus: refocusAuthorSelect,
        academicTitleDict: academicTitleDict
    };

    let addInstitutionModalProps: InstitutionsAddModalProps = {
        onClose: () => { onClose(false) },
        selectedAuthorId: selectedAuthor.length > 0 ? selectedAuthor[0].value : "",
        isSingleInstitution: false,
        cleanSelects: cleanSelects,
        refocus: refocusInstitutionSelect
    }

    const renderAuthor = () => {
        return <SelectInput {...getSelectProps(
            "Imię i Nazwisko / Uprawnienia",
            "Wpisz dane autora",
            prepareSelect(ProtocolDictionaryTypes.Authors),
            selectedAuthor,
            loading,
            AuthorSelectOnChange,
            cleanAuthorSelect,
            getSelectButtonFieldProps(() => { handleAddAuthorProposalClick() }, "Dodaj propozycję Autora"),
            !authorModalVisible,
            getOptionsFieldErrorMsg("Nie odnaleziono Autora", "Dodaj Autora tutaj.", handleAddAuthorProposalClick),
            functionsPermissions.proposeNewDictValue.active,
            focusAuthorSelect,
            setFocusAuthorSelect
        )} />
    }

    const renderInstitution = () => {
        return <SelectInput {...getSelectProps(
            "Instytucja",
            "Wpisz nazwę instytucji",
            prepareSelect(ProtocolDictionaryTypes.Institutions, true),
            selectedInstitution,
            !(selectedAuthor.length > 0) || loading,
            InstitutionSelectOnChange,
            cleanInstitutionSelect,
            getSelectButtonFieldProps(() => { handleAddInstitutionProposalClick() }, "Dodaj propozycję Instytucji"),
            !institutionModalVisible,
            getOptionsFieldErrorMsg("Nie odnaleziono Instytucji", "Dodaj Instytucję tutaj.", handleAddInstitutionProposalClick),
            functionsPermissions.proposeNewDictValue.active,
            focusInstitutionSelect,
            setFocusInstitutionSelect,
            true,
            [
                { name: getTabTitle('Twoje Instytucje', filteredInstitutionsDictPerAuthor!.length), onClick: () => { onClickTabbarOption(InstitutionDictionaryType.PerAuthor) } },
                ...functionsPermissions.proposeNewDictValue.active ? [{ name: getTabTitle('Wszystkie Instytucje', filteredInstitutionsDictMinusAuthor!.length!), onClick: () => { onClickTabbarOption(InstitutionDictionaryType.Full) } }] : []
            ],
            selectedTab,
            1,
            prepareSelect(ProtocolDictionaryTypes.InstitutionsPerAuthor)
        )} />
    }

    const renderCommentBtn = () => {
        if (props.objectType === ObjectType.KRO) return renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.oprac_sekcja, false, "18-20. Opracowujący", props.setNewCommentFieldDetails!, KROFieldDict.oprac_sekcja);
        else return renderSectionCommentBtn(props.markedFieldForCommentFiltering === KRTZFieldDict.oprac_sekcja, false, "5-7. Opracowujący", props.setNewCommentFieldDetails!, KRTZFieldDict.oprac_sekcja)
    }

    const getFieldName = () => {
        return props.objectType === ObjectType.KRO ? KROFieldDict.oprac_sekcja : KRTZFieldDict.oprac_sekcja;
    }

    return (
        <>
            {loading && <div className="spinner-on-top"><Spinner isMist={true} spinnerClass={ClassNameSpinner.Big} /></div>}
            <div ref={(node: any) => { if (!props.collectiveEdition) getFieldRef(node, getFieldName(), props.getMapForComment!) }} style={{ width: "100%" }}></div>
            <div ref={(node) => props.objectType === ObjectType.KRO ? getItemRef(node, NavHeadingsKROEnum.ElaboratorsAndInstitutions, props.getMapForNavScroll!) :
                props.objectType === ObjectType.KRTZ && getItemRef(node, NavHeadingsKRTZEum.ElaboratorsAndInstitutions, props.getMapForNavScroll!)} style={{ width: '100%' }}>
                <div onClick={() => { if (props.setCommentsFilter) props.setCommentsFilter(getFieldName()); }}>
                    {props.sectionTitle}
                </div>
                <br />
                {props.collectiveEdition ? <>
                    <div className='elaboratorsSearchContainer collective-block'>
                        {renderAuthor()}
                        {renderInstitution()}
                        <div style={{ position: 'relative' }}>
                            <ButtonField {...btnFieldProps}></ButtonField>
                            <div className="collective-ellaborator-chip"><CollectiveLabelChip isAuto={false} /></div>
                        </div>
                    </div>
                    <br />
                    <div>
                        <CollectiveSelectField top={false} value={tableData} title={"Opracowujący"}
                            forms={props.forms} keyName={CollectivePreviewKey.ellaborators} actions={props.actions} single={false}
                            setActions={props.setActions} onDelete={props.onDelete}>
                            <div style={{ width: '100%' }}><Table {...tableProps} /></div>
                        </CollectiveSelectField>
                    </div>
                </> :
                    <>
                        {!props.editMode && props.isKR && renderCommentBtn()}
                        {props.editMode && <>
                            <br />
                            <div className='elaboratorsSearchContainer'>
                                {renderAuthor()}
                                {renderInstitution()}
                                <ButtonField {...btnFieldProps}></ButtonField>
                            </div>
                            <br />
                        </>}
                        <div>
                            <Table {...tableProps} />
                        </div>
                    </>}
            </div>
            {confirmation &&
                <ConfirmModal width={"660px"} height={"auto"}
                    confirmTitle={"Tak, usuń osobę opracowującą"}
                    onConfirm={confirm}
                    cancelTitle={"Anuluj"}
                    onCancel={cancel}
                    question={getQuestion()}
                    refocus={refocus}
                />}
            {authorModalVisible && <AuthorsAddModal {...addAuthorModalProps} />}
            {institutionModalVisible && <InstitutionsAddModal {...addInstitutionModalProps} />}
        </>
    )
}

export default ElaboratorsAndInstitutions;

